import styled from 'styled-components'

export const SearchScreenFilterContainer = styled.div<{ theme }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 0;

  @media (min-width: ${props => props.theme.screen.mdMin}) {
    padding: 16px 0;
  }

  @media (min-width: ${props => props.theme.screen.lgMin}) {
    padding: 24px 48px;
    margin: 0px;
  }
`
export const makeFiltersLoaderContainer = () => {
  return `width: 100%;
          border-radius: 8px;
          box-shadow: 0px 0px 0px rgba(0,0,0,0.12);
          background: white;
          margin: 0 0 15px;`
}

export const ColWithCenterAlign = styled.div`
  height: 38px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  padding-right: 12px;
  padding-left: 6px;
`

export const SearchSidebarContainer = styled.div``
